<template>
	<el-tabs type="border-card">
		<el-tab-pane label="操作记录">
			<el-table :data="lie" style="width: 100%" stripe>
				<el-table-column prop="jilu" label="操作" width="380">
				</el-table-column>
				<el-table-column prop="zhanghao" label="账号" width="180">
				</el-table-column>
				<el-table-column prop="shijian" label="操作时间" width="180">
				</el-table-column>
				<el-table-column prop="url" label="链接">
				</el-table-column>
			</el-table>
			<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao"
			 :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;">
			</el-pagination>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	var that;
	export default {
		data() {
			return {				
				zongshu: 0,
				so: {
					ye: 1,
					jitiao: 10,
				},
				lie:[]
			}
		},
		created() {
			that=this;
			that.CSH();
		},
	  methods: {
		  CSH() {
		  	this.$post('k=caozuojilu', that.so, function(s) {
		  		that.lie = s.shu.lie;
		  		that.zongshu = Number(s.shu.zongshu);
		  	});
		  },		 
		},
	}
</script>

<style>
</style>
